import { withCompInfo } from '../../core/withCompInfo'
import { DisqusCommentsDefinition, DisqusCommentsProps } from './types'

export const props = withCompInfo<DisqusCommentsProps, DisqusCommentsDefinition>(['compData'], ({ compData }) => {
	return { disqusId: compData.disqusId }
})
